<template>
  <div class="waiting">404</div>
</template>

<script>
import trackEvent from '@/common/js/track'

const Waiting = {
  props: [],
  data() {
    return {}
  },
  mounted() {
    try {
      this.init()
    } catch (err) {
      console.log(err)
    }
  },
  methods: {
    async init() {
      const userInfo = await this.getUserInfo()
      // 404页面埋点
      trackEvent({
        eventId: 'sailing_c_h5_tech_js_error_bt',
        eventLabel: '路由加载错误捕捉',
        ...{
          type: '404',
          msg: 'vue_page_404',
          uid: userInfo.uid || -1,
        },
      })
    },
    async getUserInfo() {
      const res = (await SodaBridge('getUserInfo')) || {}
      return res.data || {}
    },
  },
}
export default Waiting
</script>

<style scoped lang="stylus">
.waiting{
  width: 100%;
  height: 100%;
  position: relative;
  overflow: auto;
}
</style>
